import { useEffect, useState } from "react";
import { leftPanelActions } from "../../../../../context/actions/leftPanelActions";
import { modalActions } from "../../../../../context/actions/modalActions";
import { sidePanelActions } from "../../../../../context/actions/sidePanelActions";
import useStore from "../../../../../context/useStore";
import dataService from "../../../../../helpers/dataService";
import Jury from "../../Jury/Jury";
import EPARList from "../../ARList/EPARList";
import EpRecipientsV2 from "../EpRecipientsV2/EpRecipientsV2";

export const useEPEditDetailV2 = (ep, setErrors) => {
  const [state, dispatch] = useStore();
  const lpActions = leftPanelActions(state, dispatch);
  const mActions = modalActions(state, dispatch);
  const spActions = sidePanelActions(state, dispatch);

  const [myEp, setMyEp] = useState(ep);
  const [epRecipients, setEpRecipients] = useState([]);
  const [isGettingRecipients, setIsGettingRecipients] = useState(true);

  const [allSectors, setAllSectors] = useState([]);
  const [allMembers, setAllMembers] = useState({ userManagers: [] });
  const [jury, setJury] = useState([]);
  const [juryFetched, setJuryFetched] = useState(ep.id ? false : true);
  const [allMembersFetched, setAllMembersFetched] = useState(false);
  const [sectorsFetched, setSectorsFetched] = useState(false);
  const [juryDepsFetched, setJuryDepsFetched] = useState(false);

  useEffect(() => {
    setMyEp(ep);
    fetchJuryDatas();
    if (ep.id) {
      getEpRecipients();
    }
  }, [ep]);

  useEffect(() => {
    if (juryFetched && allMembersFetched && sectorsFetched) {
      setJuryDepsFetched(true);
    }
  }, [juryFetched, allMembersFetched, sectorsFetched]);

  const fetchJuryDatas = () => {
    if (ep.id && state.auth.user.role != "AGENT_PARTNER") {
      dataService.get(`eps/${ep.id}/jury`, setJury, setErrors, () =>
        setJuryFetched(true),
      );
    } else {
      setJuryFetched(true);
    }
    dataService.get(`sectors/${ep.sector}`, setAllMembers, setErrors, () =>
      setAllMembersFetched(true),
    );
    dataService.get(
      `sectors`,
      setAllSectors,
      setErrors,
      setSectorsFetched(true),
    );
  };

  const getEpRecipients = () => {
    setIsGettingRecipients(true);
    dataService.get(
      `eps/${ep.id}/lister-inscriptions`,
      (data) => setEpRecipients(Array.isArray(data) ? data : []),
      (err) => {},
      () => setIsGettingRecipients(false),
    );
  };

  const openJury = () => {
    lpActions.updateLeftPanel({
      isOpen: true,
      content: (
        <Jury
          ep={ep}
          myjury={jury}
          allMembers={allMembers}
          sectors={allSectors}
          fetchJuryDatas={fetchJuryDatas}
        />
      ),
    });
  };

  const openRecipients = () => {
    mActions.updateModal({
      isOpen: true,
      content: <EpRecipientsV2 ep={ep} />,
      style: { zIndex: "999999" },
    });
  };

  const openAR = () => {
    lpActions.updateLeftPanel({
      isOpen: true,
      content: <EPARList epData={ep} />,
    });
  };

  return {
    myEp,
    setMyEp,
    epRecipients,
    isGettingRecipients,
    allSectors,
    allMembers,
    jury,
    juryDepsFetched,
    fetchJuryDatas,
    openJury,
    openRecipients,
    openAR,
    spActions,
  };
};
